import styled, { css } from 'styled-components';
import { Form as FormWeb } from '@unform/web';

import theme from '../../styles/theme';

import ImagemMassaInicial from '../../assets/images/massa-inicial/imagem-massa-inicial.svg';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 500px;
  height: 100vh;
  overflow-y: hidden;
  padding: 32px 40px 0 0;
  background-color: #ffff;
`;

export const ContainerImage = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
`;

export const HeaderContainer = styled.div`
  margin-left: 60px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ContainerFormMassaInicial = styled.div`
  grid-template-rows: 13% 20% 5% 65%;
  background-color: #ffff;

  ${({ display }) =>
    display
      ? css`
          display: ${display};
        `
      : ''};
  }
`;

export const ImageBackground = styled.div`
  background-image: url(${ImagemMassaInicial});
  background-repeat: no-repeat;
  background-position-y: bottom;
  background-position-x: left;
  background-size: contain;
  background-color: #ffff;
  flex: 1;
`;

export const HeaderTitulo = styled.h1`
  font-family: 'unimed_slabbold';
  color: ${theme.titleGray};
  font-size: 34px;
`;

export const ContainerProgressBar = styled.div`
  margin-left: -5px;
`;

export const TextoPasso = styled.div`
  font: bold 16px 'Calibri';
  color: ${theme.colorGray};
  text-transform: uppercase;
  margin-left: 5px;
`;

export const Form = styled(FormWeb)`
  min-height: 550px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
